import * as React from "react";

function BulpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M30.28 44 29 28.27a1.85 1.85 0 0 0-3.32-1 1.85 1.85 0 0 0 1.48 3h9.74a1.85 1.85 0 0 0 1.48-3 1.85 1.85 0 0 0-3.32 1L33.72 44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.41 44c0-5.41 4.35-10.27 6.6-13.66a14.34 14.34 0 0 0 2.38-8.81C46 14.35 41 8 32 8s-14.41 6.08-14.41 14.38a14.33 14.33 0 0 0 2.48 8.09c2.3 3.38 6.52 8.12 6.52 13.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 52a4 4 0 0 0 8 0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 44,
    width: 16,
    height: 8,
    rx: 3
  }));
}

export default BulpIcon;